import { render } from "./SlideDesignPreview.vue?vue&type=template&id=53d0565a&scoped=true&ts=true"
import script from "./SlideDesignPreview.vue?vue&type=script&lang=ts"
export * from "./SlideDesignPreview.vue?vue&type=script&lang=ts"

import "./SlideDesignPreview.vue?vue&type=style&index=0&id=53d0565a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d0565a"]])

export default __exports__